<template>
	<div class="zoom">
		<div class="photo1" ref="photo" v-parallax-fit="photo1"></div>
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	name: 'slide27',
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/16a.jpg',
					url: 'https://jacobin.com/2022/08/how-oakland-tenants-forced-their-landlord-to-turn-over-the-keys',
					link_title: {
						'en': 'How Oakland Tenants Forced Their Landlord to Turn Over the Keys',
						'es': 'Cómo los inquilinos de Oakland obligaron a su arrendador a entregar las llaves'
					}
				},
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/16b.jpg',
					url: 'https://www.businessinsider.in/policy/economy/news/renter-activists-crashed-a-dc-landlords-conference-to-protest-corrupt-greed-and-rising-rents/articleshow/94229175.cms',
					link_title: {
						'en': 'Renter activists crashed a DC landlords conference to protest \'corrupt greed\' and rising rents',
						'es': 'Activistas de inquilinos irrumpieron en una conferencia de propietarios de DC para protestar contra la "codicia corrupta" y el aumento de los alquileres'
					}
				},
			],
			text: {
				'en': '"...beyond permanent affordability, resident control and influence on land-use decisions should be at the center of housing, whether public, private, or provided by a CLT [community land trust]...Housing should be a manifestation of the residential needs of those who live there, not a vehicle for someone else’s profit accumulation."',
				'es': '"... más allá de la asequibilidad permanente, el control de los residentes y la influencia en las decisiones sobre el uso de la tierra deben estar en el centro de la vivienda, ya sea pública, privada o provista por un CLT [fideicomiso de tierras comunitarias]... La vivienda debe ser una manifestación de la necesidades residenciales de quienes viven allí, no un vehículo para la acumulación de ganancias de otra persona".'
			}
		};
		const audio = '/themes/rise-theme/resources/assets/audio/vanessa/6.mp3';
		const text = {
			'en': 'Across the country, tenants are organizing unions and co-ops to fight back against the harmful practices of Wall Street landlords and create more permanently affordable, community controlled, secure housing. By fighting to pass policies that treat housing more as a social good rather than just a commodity to be bought and sold on the market, they are working to fight displacement, keep our communities affordable, and keep families in their homes.',
			'es': 'En todo el país, los inquilinos están organizando sindicatos y cooperativas para luchar contra las prácticas nocivas de los propietarios de Wall Street y crear viviendas seguras, controladas por la comunidad y más asequibles de forma permanente. Al luchar para aprobar políticas que traten la vivienda más como un bien social en lugar de solo una mercancía para comprar y vender en el mercado, están trabajando para luchar contra el desplazamiento, mantener nuestras comunidades asequibles y mantener a las familias en sus hogares.'
		};
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(180px) rotate(-3deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$readMore.value = text;
					this.$evidence.value = JSON.stringify(evidence);
				}
			});
		});

		this.mutationObserver.observe(this.$refs.photo, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}, data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/vanessa/6.srt',
				'es': '/themes/rise-theme/resources/assets/audio/vanessa/6_es.srt'
			},
			mutationObserver: null,
			photo1: [
				{
					start: 36400,
					end: 36800,
					fromStyle: { transform: 'translateY(-830px) rotate(0deg)' },
					toStyle: { transform: 'translateY(-420px) rotate(0deg)' }
				},
				{
					start: 36800,
					end: 37400,
					fromStyle: { transform: 'translateY(-420px) rotate(0deg)' },
					toStyle: { transform: 'translateY(180px) rotate(-3deg)' }
				},
				{
					start: 38000,
					end: 38600,
					fromStyle: { transform: 'translateY(180px) rotate(-3deg)' },
					toStyle: { transform: 'translateY(2100px) rotate(0deg)' }
				},
			],
		};
	}
}
</script>

<style lang="scss" scoped>
.photo1 {
	position: fixed;
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/27_photo1.png');
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: 530px;
	height: 630px;
	transition: 0.3s;
	transform-origin: center;
	z-index: 5;
	left: calc(50% - 270px);
	top: 27vh;

	@media(min-width: 600px) and (max-width: 1280px) {
		top: 0;
		zoom: 0.65;
	}

	@media(max-width: 600px) {
		left: calc(50% - 110px);
		width: 220px;
	}

	@media(max-width: 400px) {
		left: calc(50% - 110px);
		width: 220px;
		top: -170px;
	}
}</style>
